import { useCallback, useEffect, useRef, useState } from "react";
import { assignDbs } from "@services/api";
import { ROUTING_MAIN_TYPE, USE_FIXTURES } from "../constants";
import { assignDbsFixture } from "../__fixtures__/fixtureStore";
import { notifySuccess, notifyError } from "@components/ds/notify";

// Wraps the POST /assign-dbs round-trip used by Assign / Unassign / Misroute.
// The web UI fires-and-forgets the response then calls fetchAssignedDbs() to
// refresh — we mirror that exactly: on success the caller invokes the
// passed-in `reload` (returned from useRoutingData).

const useAssignDbs = ({ reload, type = ROUTING_MAIN_TYPE } = {}) => {
  const [submitting, setSubmitting] = useState(false);
  const isMounted = useRef(true);
  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const submit = useCallback(
    async ({ tps, cp_db_id, route_id, successMessage }) => {
      if (!Array.isArray(tps) || tps.length === 0) {
        notifyError("No customers selected");
        return false;
      }
      setSubmitting(true);
      try {
        if (USE_FIXTURES) {
          assignDbsFixture({ tps, cp_db_id, route_id });
        } else {
          await assignDbs({ tps, cp_db_id, route_id }, type);
        }
        notifySuccess(successMessage || "Saved");
        if (reload) await reload();
        return true;
      } catch (e) {
        const msg =
          e?.response?.data?.error ||
          e?.response?.data?.message ||
          e?.message ||
          "Assignment failed";
        notifyError(msg);
        return false;
      } finally {
        if (isMounted.current) setSubmitting(false);
      }
    },
    [reload, type],
  );

  return { submit, submitting };
};

export default useAssignDbs;
